// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"ace06075","container":"e01a8d0c","iframe":"aa477b52","loadingContainer":"bcc472b7","card":"c52928de"};